module.exports = __webpack_public_path__ + "static/img/us.7978889a.svg";